import { useCallback, useEffect, useState } from "react";

import { FETCH_SETTINGS_DETAILS } from "@/queries";
import { useNorthbeamQuery, useUpdateUserFeatureFlag } from "@hooks/http";
import { type FetchSettingsDetails } from "@north-beam/nb-client-side";
import { Modal } from "@shared/modal";

export const SalesEducationModal = () => {
  const { data, loading } = useNorthbeamQuery<FetchSettingsDetails>(
    FETCH_SETTINGS_DETAILS,
    {},
  );

  const featureFlags = data?.me.featureFlags;
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    setOpen(featureFlags?.showSalesV3FirstTimeEducation);
  }, [featureFlags?.showSalesV3FirstTimeEducation]);

  const [updateUserFeatureFlag] = useUpdateUserFeatureFlag();

  const onClose = useCallback(async () => {
    setOpen(false);
    await updateUserFeatureFlag("showSalesV3FirstTimeEducation", false);
  }, [updateUserFeatureFlag]);

  if (loading) {
    return null;
  }

  const currentVideoUrl = new URL(
    "https://www.youtube.com/embed/uJMocV_YttE?si=ZNnPYlXK-YSypGzF",
  );
  // Don't show related videos
  currentVideoUrl.searchParams.set("rel", "0");
  // Don't show video title
  currentVideoUrl.searchParams.set("showinfo", "0");
  // Don't show progress bar
  currentVideoUrl.searchParams.set("autohide", "1");

  const newVideoUrl = currentVideoUrl.toString();

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      titleContent={
        <div className="text-lg font-semibold">
          Welcome to the Enhanced Sales Page!
        </div>
      }
    >
      <p>
        Modern brands can now scale profitably with advanced functionality and
        greater granularity to test, forecast, and scale marketing efforts with
        confidence.
      </p>
      <iframe
        width="100%"
        height="350px"
        src={newVideoUrl}
        title="YouTube video player"
        frameBorder="0"
        allow={
          "accelerometer; clipboard-write; encrypted-media; " +
          "gyroscope; picture-in-picture; web-share"
        }
        allowFullScreen
      />
      <div className="mt-5 flex items-center">
        For more updates,
        <a
          href="https://docs.northbeam.io/docs/sales-page"
          target="_blank"
          rel="noreferrer"
          className="ml-2"
        >
          check out the knowledge base
        </a>
      </div>
    </Modal>
  );
};
